import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { BrandDeleteCard } from './components/BrandDeleteCard';
import { BrandDetailsCard } from './components/BrandDetailsCard';
import { ProductsCard } from './components/ProductsCard';

export function BrandDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const brandQueryResults = useQuery({
        queryKey: ['brand', id],
        queryFn: () => Api.Products.Brands.getBrand(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={brandQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <BrandDetailsCard brand={data} />
                            <ProductsCard
                                brand={data}
                                refetch={brandQueryResults.refetch}
                            />

                            {!data.products.length && (
                                <Can I="delete" a="Product">
                                    <BrandDeleteCard brand={data} />
                                </Can>
                            )}
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
